import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-m-road",
  "use": "icon-m-road-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-m-road\"><g clip-path=\"url(#icon-m-road_a)\"><path d=\"m14.05 7-12 31M25.902 7 38.05 38m-18-27v4.35m0 5.8v5.8m0 7.25V40m-19-34h38\" stroke=\"#000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></g><defs><clipPath id=\"icon-m-road_a\"><path fill=\"#fff\" d=\"M0 0h40v40H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol